module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "logo-link",
    on: {
      "click": function($event) {
        _vm.changePage("Home")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "Logo"
    }
  })])]), _c('div', {
    staticClass: "cart"
  }, [_c('a', {
    staticClass: "cart-link"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/cart.svg"),
      "alt": "Cart"
    }
  }), (_vm.cartShow) ? _c('span', {
    staticClass: "cart-count"
  }) : _vm._e()]), _c('div', {
    staticClass: "cart-submenu"
  }, [_c('ul', {
    staticClass: "cart-list"
  }, _vm._l((_vm.productsInCart), function(product, key) {
    return _c('li', {
      staticClass: "cart-product"
    }, [_c('a', {
      staticClass: "product-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })]), _c('div', {
      staticClass: "product-description"
    }, [_c('a', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(product.name))]), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$ " + _vm._s(product.price))])]), _c('a', {
      staticClass: "product-remove",
      on: {
        "click": function($event) {
          _vm.removeFromCart(key)
        }
      }
    })])
  })), _c('div', {
    staticClass: "cart-subtotal"
  }, [_c('span', [_vm._v("Subtotal")]), _c('span', [_vm._v("$ " + _vm._s(_vm.cartAmount()))])]), _c('div', {
    staticClass: "cart-links"
  }, [_c('a', {
    staticClass: "cart-view",
    on: {
      "click": function($event) {
        _vm.changePage("Cart")
      }
    }
  }, [_vm._v("View Cart")]), _c('a', {
    staticClass: "cart-checkout",
    on: {
      "click": function($event) {
        _vm.changePage("Checkout")
      }
    }
  }, [_vm._v("Checkout")])])])]), _c('a', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_c('div', {
    staticClass: "toggle-icon",
    class: {
      open: _vm.showMenu
    }
  }, [_c('span'), _c('span'), _c('span')]), _c('transition', {
    attrs: {
      "name": "toggle-menu"
    }
  }, [(_vm.showMenu) ? _c('nav', {
    staticClass: "nav"
  }, _vm._l((_vm.pages), function(page) {
    return _c('a', {
      staticClass: "nav-link",
      on: {
        "click": function($event) {
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  })) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1f7b103e"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainHeader.vue
// module id = 122
// module chunks = 0